import React, { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useHistory } from 'react-router-dom';
import IdleWarningDialog from './Dialogs/IdleWarningDialog';
import { connect } from 'react-redux';
import { systemParameters, timeouts } from '../../Config/constants';

export const IdleController = (props) => {

    var timeout = 20000000;
    var popupTimeout = 10000000;
    if (props.general.systemParameters && props.general.systemParameters.some(x => x.id === systemParameters.ShopfloorAppSettings)) {
        timeout = JSON.parse(props.general.systemParameters.find(x => x.id === systemParameters.ShopfloorAppSettings).value).timeouts.find(x => x.name === timeouts.LOGOUTTIMEOUT).valueInSeconds * 1000;
        popupTimeout = JSON.parse(props.general.systemParameters.find(x => x.id === systemParameters.ShopfloorAppSettings).value).timeouts.find(x => x.name === timeouts.SESSIONTIMEOUTPOPUP).valueInSeconds * 1000;
    }

    const [remaining, setRemaining] = useState(timeout)
    const [isIdle, setIsIdle] = useState(false);
    const handleOnActive = () => setIsIdle(false);
    const handleOnIdle = () => setIsIdle(true);

    let history = useHistory();

    const {
        getRemainingTime,
    } = useIdleTimer({
        timeout,
        onActive: handleOnActive,
        onIdle: handleOnIdle
    })


    useEffect(() => {
        setRemaining(getRemainingTime())

        setInterval(() => {
            setRemaining(getRemainingTime())

        }, 1000)
        // eslint-disable-next-line
    }, [])

    let dialogOpen = false;
    if (remaining < popupTimeout + 1000) {
        if (!dialogOpen) {
            dialogOpen = true;
        }
    }

    if (dialogOpen && remaining > popupTimeout + 2000) {
        dialogOpen = false;
    }

    if (isIdle) {
        dialogOpen = false
        history.push('/logout');

    }

    return <React.Fragment>
        {(props.user.userInfo !== null && props.user.userInfo !== undefined) &&
            <IdleWarningDialog dialogOpen={dialogOpen} remaining={remaining} user={props.user.userInfo.given_name} popupTimeout={popupTimeout}></IdleWarningDialog>
        }
    </React.Fragment>
}

const mapStateToProps = state => ({
    user: state.user
})

export default connect(mapStateToProps)(IdleController)